
import React from "react";
import { Link } from "react-router-dom";

const formatTime = (dateValue) => {
  if (!dateValue) return "Time not set";

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) return "Time not set";

  return date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const TodoListCard = ({ todoList = [], loading = false }) => {
  const activities = Array.isArray(todoList) ? todoList : [];

  const sortedActivities = [...activities].sort((a, b) => {
    const dateA = new Date(
      a?.type === "meetingUpdate" ? a?.meetingDateTime : a?.callDateTime
    ).getTime();

    const dateB = new Date(
      b?.type === "meetingUpdate" ? b?.meetingDateTime : b?.callDateTime
    ).getTime();

    return (
      (Number.isNaN(dateA) ? Infinity : dateA) -
      (Number.isNaN(dateB) ? Infinity : dateB)
    );
  });

  return (
    <section className="todo-card">

      {/* Activity Header */}
      <div className="todo-header">
        <div className="todo-heading">
          <div className="todo-icon">
            <i className="fa fa-calendar-check-o" />
          </div>

          <div>
            <h4>Scheduled Activities</h4>
            <p>Your calls and meetings for today</p>
          </div>
        </div>

        <span className="todo-count">
          {activities.length} Activities
        </span>
      </div>

      {/* Activity Body */}
      <div className="todo-body">
        {loading ? (
          <div className="todo-loading">
            <i className="fa fa-spinner fa-spin" />
            <span>Loading activities...</span>
          </div>
        ) : activities.length === 0 ? (
          <div className="todo-empty">
            <div className="todo-empty-icon">
              <i className="fa fa-calendar-check-o" />
            </div>

            <h4>No activities scheduled</h4>
            <p>Your scheduled calls and meetings will appear here.</p>
          </div>
        ) : (
          <div className="todo-list">
            {sortedActivities.map((item, index) => {
              const isMeeting = item?.type === "meetingUpdate";

              const activityDate = isMeeting
                ? item?.meetingDateTime
                : item?.callDateTime;

              const leadId = item?.Lead?.id;

              const contactName =
                item?.Lead?.primaryContactName ||
                item?.Lead?.companyName ||
                "Unnamed Lead";

              const companyName = item?.Lead?.companyName;

              const activityContent = (
                <>
                  <div className={`todo-item-icon ${isMeeting ? "meeting-icon" : "call-icon"}`}>
                    <i className={isMeeting ? "fa fa-handshake-o" : "fa fa-phone"} />
                  </div>

                  <div className="todo-item-content">
                    <div className="todo-item-heading">
                      <h5>{contactName}</h5>

                      <span className={`todo-type ${isMeeting ? "meeting-type" : "call-type"}`}>
                        {isMeeting ? "Meeting" : "Call"}
                      </span>
                    </div>

                    {companyName && companyName !== contactName && (
                      <p className="todo-company">
                        <i className="fa fa-building-o" />
                        {companyName}
                      </p>
                    )}

                    <div className="todo-meta">
                      <span>
                        <i className="fa fa-clock-o" />
                        {formatTime(activityDate)}
                      </span>

                      {isMeeting ? (
                        <>
                          {item?.meetingType && (
                            <span>
                              <i className="fa fa-video-camera" />
                              {item.meetingType}
                            </span>
                          )}

                          {item?.meetingType?.toLowerCase() === "offline" &&
                            item?.meetingVenue && (
                              <span>
                                <i className="fa fa-map-marker" />
                                {item.meetingVenue}
                              </span>
                            )}
                        </>
                      ) : (
                        item?.contactType && (
                          <span>
                            <i className="fa fa-phone" />
                            {item.contactType}
                          </span>
                        )
                      )}
                    </div>
                  </div>

                  <div className="todo-arrow">
                    <i className="fa fa-angle-right" />
                  </div>
                </>
              );

              const itemKey =
                item?.id ?? `${isMeeting ? "meeting" : "call"}-${leadId || "unknown"}-${index}`;

              return leadId ? (
                <Link
                  key={itemKey}
                  to={`/b2b/lead/activity/${leadId}`}
                  className={`todo-item ${isMeeting ? "meeting" : "call"}`}
                  title={`Open ${contactName} activity`}
                >
                  {activityContent}
                </Link>
              ) : (
                <div
                  key={itemKey}
                  className={`todo-item ${isMeeting ? "meeting" : "call"}`}
                >
                  {activityContent}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default TodoListCard;
